export default function PastExperience() {
  return (
    <section className="relative py-0 bg-[#0A0F1E]">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Left - Image Panel */}
        <div className="relative h-[600px] lg:h-auto overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/2109b5145bb42be11912f568d16ee111.jpg"
            alt="FIFA World Cup Experience"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1E]/40 to-transparent"></div>
        </div>

        {/* Right - Content Panel */}
        <div className="relative flex items-center py-24 px-16 bg-[#0A0F1E]">
          <div className="max-w-[540px] space-y-10">
            {/* Eyebrow */}
            <div className="flex items-center gap-5">
              <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
              <p className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
                Proven Track Record
              </p>
            </div>

            {/* Headline */}
            <h2 className="text-5xl font-light text-white leading-[1.15] tracking-[-0.02em]">
              <span className="font-semibold">World-Class Experience</span>
            </h2>

            {/* Vimeo Video — moved above body text, 15% bigger */}
            <div className="w-[115%] rounded-sm overflow-hidden border border-white/10">
              <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                <iframe
                  src="https://player.vimeo.com/video/1173492839?badge=0&autopause=0&player_id=0&app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  title="Qatar Fifa World Cup FanID Medal"
                ></iframe>
              </div>
            </div>

            {/* Body */}
            <div className="space-y-6 text-[15px] leading-[1.8] text-white/60 font-light">
              <p>
                Our leadership team brings decades of experience in technology deployment, operational management, and strategic execution at the highest levels.
              </p>
              <p>
                We have designed and delivered mission-critical systems for global events, including comprehensive RFID and access control infrastructure for FIFA World Cup tournaments—managing millions of credentials, thousands of access points, and real-time security operations across multiple venues.
              </p>
              <p>
                This experience informs everything we build: systems that scale, technology that performs under pressure, and platforms designed for reliability when it matters most.
              </p>
            </div>

            {/* Credential Badge */}
            <div className="pt-6">
              <div className="inline-flex items-center gap-4 px-6 py-4 border border-[#C9A96E]/30 rounded-sm bg-[#C9A96E]/5 backdrop-blur-sm">
                <div className="w-12 h-12 rounded-full bg-[#C9A96E]/20 flex items-center justify-center">
                  <i className="ri-trophy-line text-2xl text-[#C9A96E]"></i>
                </div>
                <div>
                  <p className="text-[13px] font-semibold text-white tracking-wide">
                    FIFA World Cup
                  </p>
                  <p className="text-[12px] text-white/50 tracking-wide">
                    Technology Partner
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}